import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: module.hot ? '/front' : '/',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: { name: 'form' },
    },
    {
      path: '/form',
      name: 'form',
      component: () => import(/* webpackChunkName: "promotion_request_form" */ './views/PromotionRequestForm.vue'),
    },
    {
      path: '/promotion-change-form/:id-:token',
      name: 'promotion-change-form',
      component: () => import(/* webpackChunkName: "promotion_change_form" */ './views/PromotionChangeForm.vue'),
      props: route => ({
        routeProjectId: route.params.id,
        routeEditToken: route.params.token,
      }),
    },
    {
      path: '/poc-approval-form/:id-:token',
      name: 'poc-approval-form',
      component: () => import(/* webpackChunkName: "poc_approval_form" */ './views/PromotionPocApprovalForm.vue'),
      props: route => ({
        routeProjectId: route.params.id,
        routeApprovalToken: route.params.token,
      }),
    },
  ],
})

export default router
